import { render } from "./money_launderers.vue?vue&type=template&id=1029e57e&scoped=true"
import script from "./money_launderers.vue?vue&type=script&lang=js"
export * from "./money_launderers.vue?vue&type=script&lang=js"

import "./money_launderers.vue?vue&type=style&index=0&id=1029e57e&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1029e57e"]])

export default __exports__